import { type MutableRefObject, useLayoutEffect, useRef } from "react";

/**
 * A ref that always holds the latest committed `value`, for reading inside callbacks and effects
 * that must not be re-created when it changes (a TinyMCE fetch callback, a debounced search).
 *
 * Written in a layout effect, not during render: React can render and discard work, and a render
 * that never commits must not leak its value. Layout effects run before any passive effect or
 * event handler that reads the ref.
 */
export default function useLatestRef<T>(value: T): MutableRefObject<T> {
  const ref = useRef(value);
  useLayoutEffect(() => {
    ref.current = value;
  });
  return ref;
}
